import { saveWorkflow } from '../../../components//state/actions/WorkflowResponseActions';
import { redux } from '../../../components/App';
import { checkAndUpdateForAction } from '../../../components/state/actions/ActionActions';
import { ActionModel } from '../../Shared Custom Types/ActionModel';
import { FormLoader } from '../../FormLoader';

export class ACCBISTActions {
    update(pathwayId, workflow, oldActions, form) {
        let data = workflow.rawData;

        let mainForm = form.parent != null ? form.parent : form;

        let progress = mainForm.completionProgress([]);
        let formComplete = (progress.current / progress.total) == 1;
        formComplete = true;

        if (!formComplete) {
            return [];
        }

        let requiredActions = [];

        let patientEligable = true;

        let scaleScore = data['calculatedSymptomScore'];

        var isUnder24Hours = false;
        var over4hoursSinceInjury = false;
        let injuryDateString = data['injuryOccuranceDateTime'];

        if (injuryDateString != undefined && injuryDateString != null) {
            let injuryDate = new Date(injuryDateString);
            let now = new Date();
            let msBetweenDates = Math.abs(injuryDate.getTime() - now.getTime());
            let hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
            isUnder24Hours = hoursBetweenDates <= 24;
            over4hoursSinceInjury = hoursBetweenDates >= 4;
        }

        //seekNeuroscienceReview
        var seekNeuroReview = false;
        
        if(data['isCTScanNormal'] != null && data['isCTScanNormal'] != undefined && data['isCTScanNormal'] != true) {
            seekNeuroReview = true;
        }
        else if(data['totalAWPTA'] != undefined && data['totalAWPTA'] != null && data['totalAWPTA'] > 0 && data['totalAWPTA'] < 18) {
            seekNeuroReview = true;
        }
        else if(data['timeInPTA'] != null && data['timeInPTA'] != undefined && data['timeInPTA' >= 4]) {
            seekNeuroReview = true;
        }

        if(seekNeuroReview) {
            let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'seekNeuroscienceReview', null, null, 0, false, false, Date.now(), null);

            let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'seekNeuroscienceReview', oldActions);
            if (reconsiledAction != null) {
                requiredActions.push(reconsiledAction);
            }
        }

        let physicalScore = [data['headacheBistRating'],
            data['neckHurtsBistRating'],
            data['brightLightsBistRating'],
            data['loudNoisesBistRating']];

        let vestibScore = [data['dizzySickBistRating'],
            data['closedEyesAtSeaBistRating'],
            data['troubleWithVisionBistRating'],
            data['clumsyBistRating']];

        let cognitiveScore = [data['longerToThinkBistRating'],
            data['forgetThingsBistRating'],
            data['confusedEasilyBistRating'],
            data['troubleConcentratingBistRating']];

        var eligableForACCReferralViaPhysioReccomendation = false; 

        if (!physicalScore.includes(null) && !physicalScore.includes(undefined) && !vestibScore.includes(null) && !vestibScore.includes(undefined) && !cognitiveScore.includes(null) && !cognitiveScore.includes(undefined)) {
            if ((vestibScore > physicalScore && vestibScore > cognitiveScore) || (vestibScore > 0 && data['neckHurtsBistRating'] > 0) || vestibScore > 8) {
                eligableForACCReferralViaPhysioReccomendation = true;
            }
    
            if(data['ewsCriteriaRedflag'] == true || (data['totalGCS'] != undefined && data['totalGCS'] != null && data['totalGCS'] > 0 && data['totalGCS'] < 14)) {
                let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'seniorMedicalReview', null, null, 0, false, false, Date.now(), null);
    
                let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'seniorMedicalReview', oldActions);
                if (reconsiledAction != null) {
                    requiredActions.push(reconsiledAction);
                }
            }
        }
        if (data['patientSex'] == 'femaleOption') {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if(data['patientAge'] != null && data['patientAge'] != undefined && (data['patientAge'] > 65 || data['patientAge'] < 25) && ((data['concussiveForce'] == true || data['dangerousMechanismOfOInjury'] == true) && data['alterationInMentalState'] == true)) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['timeInPTA'] != null && data['timeInPTA'] != undefined && data['timeInPTA'] > 24) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['lossOfConsciousness'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['highRiskOccupation'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['previousAlchoholOrSubstanceAbuse'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['mentalHealthDifficulties'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['historyOfMigraine'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['previousConcussionOrBrainInjury'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }
        if (data['wasRecoveryProtractedOrProblematic'] == true) {
            eligableForACCReferralViaPhysioReccomendation = true;
        }

        if (!eligableForACCReferralViaPhysioReccomendation && (scaleScore != null && scaleScore != undefined && injuryDateString != null && injuryDateString != undefined && !seekNeuroReview)) {
            if (isUnder24Hours) {
                if (scaleScore < 120) {
                    if (scaleScore > 49) {
                        let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'accReferralModerateRiskAction', null, null, 0, false, false, Date.now(), null);
    
                        let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'accReferralModerateRiskAction', oldActions);
                        if (reconsiledAction != null) {
                            requiredActions.push(reconsiledAction);
                        }
                    }
                    else {
                        let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'accReferralLowRiskAction', null, null, 0, false, false, Date.now(), null);
    
                        let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'accReferralLowRiskAction', oldActions);
                        if (reconsiledAction != null) {
                            requiredActions.push(reconsiledAction);
                        }
                    }
                }
            }
            else {
                if (scaleScore > 65) {
                    let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'accReferralModerateRiskAction', null, null, 0, false, false, Date.now(), null);
    
                    let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'accReferralModerateRiskAction', oldActions);
                    if (reconsiledAction != null) {
                        requiredActions.push(reconsiledAction);
                    }
                }
                else {
                    let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'accReferralLowRiskAction', null, null, 0, false, false, Date.now(), null);
    
                    let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'accReferralLowRiskAction', oldActions);
                    if (reconsiledAction != null) {
                        requiredActions.push(reconsiledAction);
                    }
                }
            }
        }
        else if (eligableForACCReferralViaPhysioReccomendation) {
            let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'accReferralModerateRiskAction', null, null, 0, false, false, Date.now(), null);
    
            let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'accReferralModerateRiskAction', oldActions);
            if (reconsiledAction != null) {
                requiredActions.push(reconsiledAction);
            }
        }

        var timeInPTA = data['timeInPTA'];

        if(data['ctCriteraRedflag'] == true || (timeInPTA != null && timeInPTA != undefined && timeInPTA >= 4 && data['totalAWPTA'] != null && data['totalAWPTA'] != undefined && data['totalAWPTA'] < 18)) {
            let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'ctHead', null, null, 0, false, false, Date.now(), null);

            let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'ctHead', oldActions);
            if (reconsiledAction != null) {
                requiredActions.push(reconsiledAction);
            }
        }
        
        //concussion diagnosis
        if ((data['concussiveForce'] == true || data['dangerousMechanismOfOInjury'] == true) && data['alterationInMentalState'] == true) {
            if(data['confoundingFactors'] == true) {
                let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'diagnosisConcussionConfoudningFactorsAction', null, null, 0, false, false, Date.now(), null);

                let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'diagnosisConcussionConfoudningFactorsAction', oldActions);
                if (reconsiledAction != null) {
                    requiredActions.push(reconsiledAction);
                }
            }
            else {
                let action = new ActionModel(workflow.pathwayUuid, workflow.versionUuid, 'diagnosisConcussionAction', null, null, 0, false, false, Date.now(), null);

                let reconsiledAction = checkAndUpdateForAction(pathwayId, action != null && patientEligable, action, 'diagnosisConcussionAction', oldActions);
                if (reconsiledAction != null) {
                    requiredActions.push(reconsiledAction);
                }
            }
        }

        return requiredActions;
    }

    getAutoAcceptedValues() {
        return [];
    }

    getLastAWPTADate(rawData) {

        var checks = [
            'awptaCheck5DateTime',
            'awptaCheck4DateTime',
            'awptaCheck3DateTime',
            'awptaCheck2DateTime'];

        var lastCheckDate;

        for(let check of checks) {
            let date = rawData[check];
            if (date != null && date != undefined) {
                lastCheckDate = date;
                break;
            }
        }

        return lastCheckDate;
    }
}


// WEBPACK FOOTER //
// ./src/forms/concussion01/Actions/ACCBIST-Actions.js